/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

export const titleConfigurationToCopy = {
  feeCollaboration: {
    featureName: 'Fee Collaboration',
    sectionName: 'Fees'
  },
  sharedInbox: {
    featureName: 'Shared Inbox',
    sectionName: 'Inbox'
  },
  titleCurative: {
    featureName: 'Title Curative',
    sectionName: 'Title'
  }
};
export const initialTitleConfigurationsValues = {
  borrowerWorkflowLoanProceeds: false,
  borrowerWorkflowWireInstructions: false,
  feeCollaboration: false,
  orderTitle: false,
  sharedInbox: false,
  titleCurative: false
};